
import React, { useState, useEffect } from 'react';
import ReportTable from './reportTable';
import { Box, Paper, Typography, Grid, Avatar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import bodyFat from '../../../assets/Icons/body-fat.png';
const useStyles = makeStyles((theme) => ({
    playerCombineInfo: {
        color: "#333", //"#c8102e",
        //fontSize: "0.775rem",
    },
    container: {
        //padding: theme.spacing(2),
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        // height: `435px`,
        //maxHeight: 425,
        height: '185px',
        maxHeight: '147px',
        [theme.breakpoints.only('md')]: {
            height: `245px`,
            maxHeight: '194px'
        },
        [theme.breakpoints.only('sm')]: {
            height: `245px`,
            maxHeight: '194px'
        },
        [theme.breakpoints.only('xs')]: {
            height: `345px`,
            maxHeight: '294px'
        },
    },
    BMICard: {
        padding: "1rem 0px",
    },
}));

let reportRows = [{
    name: `Standing Reach (ft' in")`, value: '', key: 'standingReachFeet', inchKey: 'standingReachInches'
},
{
    name: `Wingspan (ft' in")`, value: '', key: 'wingSpanFeet', inchKey: 'wingSpanInches'
},
{
    name: `Height (w/o shoes) (ft'in")`, value: '', key: 'heightWithOutShoesFeet', inchKey: 'heightWithOutShoesInches'
},
{
    name: `Body Weight`, value: '', key: 'bodyWeight'
},
{
    name: `Hand Width (in")`, value: '', key: 'handWidth'
},
{
    name: `Hand Length (in")`, value: '', key: 'handLength'
},
    // {
    //     name: `Body Fat Percentage`, value: '', key: 'bodyFat'
    // },
    // {
    //     name: `DEXA Body Fat Percentage`, value: '', key: 'bodyFatDXA'
    // },
];


const AnthroDetails = (props) => {
    const classes2 = useStyles();
    let anthrosData = props.data;
    const [reportData, setReportData] = useState(reportRows);
    const [loadingMessage, setLoadingMessage] = useState("");

    useEffect(() => {

        if (props.data) {
            let rows = [...reportRows];
            rows.forEach((i) => {
                let val = '';
                val = props.data[i.key] != null ? props.data[i.key] : 0;
                if (i.inchKey && props.data[i.inchKey] != null) {
                    val += `' ` + props.data[i.inchKey] + `"`;
                }
                i.value = val;
            });

            setReportData(rows);
        }

    }, [props.data])

    // Define a reusable component for displaying label and value pair
    const LabelValuePair = ({ label, dataHolder, value, loadingMessage }) => {
        return (
            <Box
                display="grid"
                gridTemplateColumns="215px 50px"
                sx={{ paddingTop: "3px", paddingBottom: "3px" }}
            >
                <Box display="flex" alignItems="center" mr={1}>
                    <img
                        alt={label}
                        src={bodyFat}
                        height={17}
                        width={17}
                        style={{
                            color: "blue",
                        }}
                    />
                    <Typography
                        component="span"
                        variant="subtitle2"
                        style={{ marginLeft: "5px" }}
                    >
                        {label}
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography
                        component="span"
                        variant="subtitle2"
                        style={{ marginRight: "5px" }}
                    >
                        :
                    </Typography>
                    <Typography
                        component="span"
                        variant="subtitle2"
                        style={{ textAlign: "center", marginLeft: 10 }}
                    >
                        {dataHolder && Object.keys(dataHolder).length ? (
                            value === null || value === "" ? (
                                "--"
                            ) : (
                                value
                            )
                        ) : (
                            <span>{loadingMessage}</span>
                        )}
                    </Typography>
                </Box>
            </Box>
        );
    };

    // Validate given value is number or not
    const validateNumber = (num) =>
        Number.isInteger(Number(num)) ? Number(num) : Number(num).toFixed(2);

    return (
        <div>
            {/* <ReportTable title={' Anthropometry Summary'}
                reportData={reportData}></ReportTable> */}
            <div style={{ padding: 10 }} id='header'>
                <Grid container alignItems='center'>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant='subtitle1' color='primary' style={{ fontWeight: 'bold' }}> {' Anthropometry Summary'} </Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div style={{ margin: 20, marginTop: 6 }}>
                <div id='BMIContainer' className={classes2.container}>
                    <Grid
                        container
                        rowGap={3}
                        sx={{
                            margin: "15px 1px 10px 5px",
                        }}
                    >
                        {
                            reportData && reportData.map((item, index) => {
                                return (
                                    <Grid key={index} item xl={3} lg={4} md={6} sm={6} xs={12}>
                                        <Box display="grid" gridTemplateColumns="210px 50px">
                                            <Box>

                                                <Typography
                                                    component="span"
                                                    variant="subtitle2"
                                                    className={classes2.playerCombineInfo}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </Box>
                                            <Typography
                                                component="span"
                                                variant="subtitle2"
                                                className={classes2.playerCombineValues}
                                            >
                                                {item.value}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    {/* <Grid container style={{ marginTop: 24 }}>
                        <Grid
                            item
                            xl={3}
                            lg={4}
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes2.BMICard}
                        >
                            <LabelValuePair
                                label="Hip Abduction Peak Force L"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.hipAbductionPeakForceL || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Hip Abduction Peak Force R"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.hipAbductionPeakForceR || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force L (RF-L)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAbductionRelativeForceL?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force R (RF-R)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAbductionRelativeForceR?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="%Difference"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAbductionRelativeForcePercentageDiff?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                        </Grid>

                        <Grid
                            item
                            xl={3}
                            lg={4}
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes2.BMICard}
                        >
                            <LabelValuePair
                                label="Hip Adduction Peak Force L"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.hipAdductionPeakForceL || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Hip Adduction PeakForce R"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.hipAdductionPeakForceR || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force L (RF-L)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAdductionRelativeForceL?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force R (RF-R)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAdductionRelativeForceR?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="%Difference"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.hipAdductionRelativeForcePercentageDiff?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                        </Grid>

                        <Grid
                            item
                            xl={3}
                            lg={4}
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes2.BMICard}
                        >
                            <LabelValuePair
                                label="Knee Extension Peak Force L"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.kneeExtensionPeakForceL || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Knee Extension Peak Force R"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.kneeExtensionPeakForceR || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force L (RF-L)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeExtensionRelativeForceL?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force R (RF-R)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeExtensionRelativeForceR?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="%Difference"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeExtensionRelativeForcePercentageDiff?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                        </Grid>

                        <Grid
                            item
                            xl={3}
                            lg={4}
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes2.BMICard}
                        >
                            <LabelValuePair
                                label="Knee Flexion Peak Force L"
                                dataHolder={anthrosData}
                                value={validateNumber(anthrosData?.kneeFlexionPeakForceL || 0)}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Knee Flexion Peak Force R"
                                dataHolder={anthrosData}
                                value={validateNumber(anthrosData?.kneeFlexionPeakForceR || 0)}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force L (RF-L)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeFlexionRelativeForceL?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force R (RF-R)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeFlexionRelativeForceR?.toFixed(2) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="%Difference"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.kneeFlexionRelativeForcePercentageDiff?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                        </Grid>

                        <Grid
                            item
                            xl={3}
                            lg={4}
                            md={4}
                            sm={6}
                            xs={12}
                            className={classes2.BMICard}
                        >
                            <LabelValuePair
                                label="Ankle Plantar Flexion PF-L"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.anklePlantarFlexionPeakForceL || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Ankle Plantar Flexion PF-R"
                                dataHolder={anthrosData}
                                value={validateNumber(
                                    anthrosData?.anklePlantarFlexionPeakForceR || 0
                                )}
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force L (RF-L)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.anklePlantarFlexionRelativeForceL?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="Relative Force R (RF-R)"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.anklePlantarFlexionRelativeForceR?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                            <LabelValuePair
                                label="%Difference"
                                dataHolder={anthrosData}
                                value={
                                    anthrosData?.anklePlantarFlexionRelativeForcePercentageDiff?.toFixed(
                                        2
                                    ) || 0
                                }
                                loadingMessage={loadingMessage}
                            />
                        </Grid>
                    </Grid> */}
                </div>
            </div>
        </div >
    )
}

export default AnthroDetails;